import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";

import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { DetalleCotizacionModal } from "./DetalleCotizacionModal";
import { EditarFaseModal } from "./EditarFaseModal";
import FiltroCotizacionesScreen from "./FiltroCotizacionesScreen";
import { useBox } from "../../Finanzas/Helper/useBox";
import { GetKey } from "../../Finanzas/Actions/GetContainer";
import { CotizacionesTablaScreen } from "./CotizacionesContainer/CotizacionesTablaScreen";
import { hoyLocal, primerDiaDelMes } from "../../../Helpers/FormatFecha";


export const CotizacionesListadoScreen = () => {
  const history = useHistory();
  const location = useLocation();

  const [cotizaciones, setCotizaciones] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalFase, setOpenModalFase] = useState(false);
  const [selectedFolio, setSelectedFolio] = useState();
  const [selectedIdcliente, setSelectedIdcliente] = useState(0);
  const [selectedFase, setSelectedFase] = useState();
  const [permisos, setPermisos] = useState();
  const puedeEditar = ["GESU", "VESC", "REWR", "CRWR", "UREG", "CWUS"].includes(permisos?.usuariorol);
  const puedeEliminar = ["GESU", "REWR", "CRWR", "UREG"].includes(permisos?.usuariorol);

  const [titulo, setTitulo] = useState('COTIZACIONES');
  const today = new Date();
  const filtrosGuardados = localStorage.getItem("filtrosCotizaciones");

  const idclienteRedirigido = location.state?.idcliente;
  const vieneDeDashboardCRM = location.state?.pantalla === "Dashboard CRM";

  // Fechas locales: evita el desfase UTC y el Invalid Date de Safari.
  const fechaInicio = primerDiaDelMes(today);
  const fechaFin = hoyLocal();

  const initialStateboxfiltros = () => {
    return {
      comparacion: "CT",
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      asesor: 0,
      cliente: -999,
      esquema: -999,
      fase: "CC",
      pv: {
        adr: [],
        sucursal: [],
      },
    };
  };

  const [boxstate, setBoxState] = useBox(
    filtrosGuardados ? JSON.parse(filtrosGuardados) : initialStateboxfiltros()
  );

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });


  const handleCloseModal = () => {
    setSelectedFolio(null);
    setOpenModal(false);
  };

  const handleOpenModalFase = (folio, fase, idcliente) => {
    if (!puedeEditar) return;
    setSelectedFolio(folio);
    setSelectedIdcliente(idcliente);
    setSelectedFase(fase);
    setOpenModalFase(true);
  };


  const handleCloseModalFase = () => {
    setSelectedFolio(null);
    setSelectedFase(null);
    setOpenModalFase(false);
  };

  useEffect(() => {
    const getPermisos = async () => {
      try {
        // setLoader({ ...loader, mostrar: true });
        const result = await request.get(`CotizacionVentas/Permisos`);
        setPermisos(result);
      } catch (error) {
        Swal.fire("Error", "No se pudieron cargar los permisos.", "error");
      } finally {
        // setLoader({ ...loader, mostrar: false });
      }
    };

    getPermisos();
  }, []);

  const actualizar = () => {
    onExecute(
      boxstate.comparacion,
      boxstate.fechaInicio,
      boxstate.fechaFin,
      boxstate.asesor,
      boxstate.cliente,
      boxstate.esquema,
      boxstate.fase
    );
  };

  useEffect(() => {
    if (
      openModalFase === undefined ||
      openModalFase === null ||
      openModalFase === true
    )
      return;
    actualizar();
  }, [openModalFase]);

  const onExecute = (
    comparacion,
    fechaInicio,
    fechaFin,
    asesor,
    cliente,
    esquema,
    fase
  ) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    // console.log(sucursales)
    // Convertimos el string a partes numéricas para evitar problemas de timezone
    const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
    const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

    // Creamos las fechas usando Date(year, monthIndex, day)
    const fechaI = new Date(anioI, mesI - 1, diaI);
    const fechaF = new Date(anioF, mesF - 1, diaF)

    const mesInicio = GetMonthNameByNumber(fechaI.getMonth() + 1).toUpperCase();
    const mesFin = GetMonthNameByNumber(fechaF.getMonth() + 1).toUpperCase();
    const anioInicio = fechaI.getFullYear();
    const anioFin = fechaF.getFullYear();

    let rangoFechas = "";
    if (anioInicio === anioFin) {
      rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
    } else {
      rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
    }
    let tituloPeriodo = "";
    if (anioInicio === anioFin) {
      // Mismo año
      tituloPeriodo =
        mesI === mesF
          ? `${mesInicio} ${anioFin}`
          : `${mesInicio} - ${mesFin} ${anioInicio}`;
    } else {
      // Años distintos
      tituloPeriodo = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
    }

    const tituloP = `COTIZACIONES ${tituloPeriodo}`;

    setTitulo(tituloP);
    return new Promise((resolve, reject) => {
      setLoader(prev => ({ ...prev, mostrar: true }));
      const peticion = `CotizacionVentas/ListadoCotizaciones?comparacion=${comparacion}&periodoinicio=${fechaInicio}&periodofin=${fechaFin}&asesor=${asesor}&cliente=${idclienteRedirigido ? idclienteRedirigido : cliente}&esquema=${esquema}&fase=${fase}&sucursal=${sucursales}&adr=${adr}`;
      request
        .get(peticion)
        .then((result) => {
          setCotizaciones(result);
          localStorage.setItem("filtrosCotizaciones", JSON.stringify(boxstate));
          setLoader({ ...loader, mostrar: false });
          return;
        })
        .catch((error) => {

          const mensaje =
            error?.response?.data ||
            error?.Mensaje ||
            "Error al cargar las cotizaciones.";
          Swal.fire("Cotización", mensaje, "error");
          setLoader({ ...loader, mostrar: false });
          return;
        });
    });
  };

  const onGeneraExcel = (
    comparacion,
    fechaInicio,
    fechaFin,
    asesor,
    cliente,
    esquema,
    fase
  ) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }

    const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
    const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

    // Creamos las fechas usando Date(year, monthIndex, day)
    const fechaI = new Date(anioI, mesI - 1, diaI);
    const fechaF = new Date(anioF, mesF - 1, diaF)

    const mesInicio = GetMonthNameByNumber(fechaI.getMonth() + 1).toUpperCase();
    const mesFin = GetMonthNameByNumber(fechaF.getMonth() + 1).toUpperCase();
    const anioInicio = fechaI.getFullYear();
    const anioFin = fechaF.getFullYear();

    let rangoFechas = "";
    if (anioInicio === anioFin) {
      rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
    } else {
      rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
    }
    let tituloPeriodo = "";
    if (anioInicio === anioFin) {
      // Mismo año
      tituloPeriodo =
        mesI === mesF
          ? `${mesInicio} ${anioFin}`
          : `${mesInicio} - ${mesFin} ${anioInicio}`;
    } else {
      // Años distintos
      tituloPeriodo = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
    }

    const tituloP = `COTIZACIONES ${tituloPeriodo}`;
    setLoader(prev => ({ ...prev, mostrar: true }));
    request
      .get(
        `CotizacionVentas/ImprimirExcelReporte?comparacion=${comparacion}&periodoinicio=${fechaInicio}&periodofin=${fechaFin}&asesor=${asesor}&cliente=${cliente}&esquema=${esquema}&fase=${fase}&sucursal=${sucursales}&adr=${adr}&titulo=${tituloP}`
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onGeneraPDF = (folio) => {
    setLoader(prev => ({ ...prev, mostrar: true }));
    request
      .get(`Cotizaciones/ImprimirPDF?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Cotizacion", JSON.stringify(error), "error");
      });
  };

  const onEliminar = (folio) => {
    if (
      permisos?.usuariorol !== "GESU" &&
      permisos?.usuariorol !== "VESC" &&
      permisos?.usuariorol !== "UREG" &&
      permisos?.usuariorol !== "REWR"
    )
      return;

    Swal.fire({
      title: "¿Eliminar cotización?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoader(prev => ({ ...prev, mostrar: true }));

        request
          .get(`CotizacionVentas/EliminarCotizacion?folio=${folio}`)
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire(
              "Eliminado",
              "La cotización fue eliminada correctamente.",
              "success"
            );

            // 🔄 Volvemos a ejecutar la búsqueda actual para refrescar la información
            onExecute(
              boxstate.comparacion,
              boxstate.fechaInicio,
              boxstate.fechaFin,
              boxstate.asesor,
              boxstate.cliente,
              boxstate.esquema,
              boxstate.fase
            );
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            const mensaje =
              error?.response?.data ||
              error?.Mensaje ||
              "Error al eliminar la cotización.";
            Swal.fire("Cotización", mensaje, "error");
          });
      }
    });
  };

  // console.log(permisos)

  const onRegresar = () => {
    localStorage.removeItem("filtrosCotizaciones");

    if (idclienteRedirigido) {
      history.push("/DashClientes/Main", { idcliente: idclienteRedirigido });
    }
    else if (vieneDeDashboardCRM) {
      history.push("/DashClientes/Main");
    }
    else {
      history.push("/Ventas/Main")

    }
  }

  return (
    <PlantillaScreen
      titulo={titulo}
      className={"cotizaciones-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="cotizaciones-actions">
        <div
          className="cotizaciones-actions-regresar"

          onClick={() => onRegresar()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="cotizaciones-actions-filtro">
          {permisos && permisos.usuariorol ? (
            <FiltroCotizacionesScreen
              onExecute={onExecute}
              boxState={boxstate}
              onBoxChange={setBoxState}
              permisos={permisos}
            />
          ) : (
            <div className="text-center p-4 text-gray-500"></div>
          )}
        </div>
        <div className="buttons">
          <button
            className="excel"
            onClick={() =>
              onGeneraExcel(
                boxstate.comparacion,
                boxstate.fechaInicio,
                boxstate.fechaFin,
                boxstate.asesor,
                boxstate.cliente,
                boxstate.esquema,
                boxstate.fase
              )
            }
          >
            <i className=" icon-file-excel" /> Excel
          </button>

          {puedeEditar ? (
            <button
              className="cotizaciones-header-agregar-linea"
              onClick={() =>
                history.push("/Ventas/RegistrarCotizacion", {
                  folio: "XXXXX",
                  puedeEliminar: puedeEliminar
                })
              }
            >
              <AddCircleOutlineIcon /> Agregar
            </button>
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <CotizacionesTablaScreen
        cotizaciones={cotizaciones}
        puedeEditar={puedeEditar}
        puedeEliminar={puedeEliminar}
        onGeneraPDF={onGeneraPDF}
        handleOpenModalFase={handleOpenModalFase}
        onEliminar={onEliminar}
        actualizarLista={actualizar}
      />
      <EditarFaseModal
        open={openModalFase}
        onClose={handleCloseModalFase}
        folio={selectedFolio}
        faseCotizacion={selectedFase}
        idcliente={selectedIdcliente}
      />
      <DetalleCotizacionModal
        open={openModal}
        onClose={handleCloseModal}
        folio={selectedFolio}
      />
    </PlantillaScreen>
  );
};
